<template>
  <div>
    <BCard
      v-if="source === 'balances'"
      body-class="border rounded"
      class="!mb-0"
    >
      <div class="flex flex-row justify-between items-center">
        <div class="flex flex-row items-center">
          <span class="text-[#737373]">{{ title }}</span>
          <img
            v-b-tooltip="{
              title: tooltip,
              placement: 'top',
              triggers: 'hover',
              customClass: 'dark-tooltip double-text-tooltip'
            }"
            :src="icon"
            alt="Komerce"
            class="ml-[5px] cursor-pointer"
            width="16"
          >
        </div>
        <BButton
          variant="link"
          class="!text-[#0A0A0A] !p-0"
          @click="onClick"
        >
          <b-icon
            icon="arrow-repeat"
            font-scale="1.5"
          />
        </BButton>
      </div>
      <BSpinner
        v-if="loading"
        class="ml-1 !size-[20px] mb-[1rem] mt-[.75rem]"
        variant="primary"
      />
      <div
        v-else
        class="text-black text-3xl ml-[5px] mb-[1rem] mt-[.5rem] font-medium"
      >
        {{ total }}
      </div>
      <slot name="extra-content" />
    </BCard>
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    onClick: {
      type: Function,
      default: () => null,
    },
    icon: {
      type: String,
      default:
        'https://storage.googleapis.com/komerce/assets/icons/info-circle.svg',
    },
    source: {
      type: String,
      default: '',
    },
    imagePath: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      IDR,
    }
  },
  computed: {
    total() {
      if (this.source === 'balances') {
        if (!this.item || this.item.balance === undefined || this.item.balance === null) return IDR(0)
        return IDR(this.item.balance)
      }
      return ''
    },
  },
}
</script>
